module.exports = __webpack_public_path__ + "static/media/check.7d5edc58.svg";